'use strict';

const {
	READ_CLUSTER_DATA,
	READ_PROJECTS_CLUST,
	ZOHO_AUTH,
	REGISTER_USER,
	SHARED_DETAILS,
	UPDATE_SHARE_CLUSTER,
	READ_REPORT,
	ADD_CLUSTER,
	RESET_PASSWORD,
	READ_BASIC_USER_DATA,
	RESEND_VERIFICATION,
	ADD_PROJECTS,
	ADD_REPORT,
	ADD_TEMPLATE,
	UPDATE_TEMPLATE,
	FILES_TEMPLATE,
	REMOVE_TEMPLATE,
	ADD_RAW_FILE,
	DOWNLOAD_RAW_FILES,
	SHARE_CLUSTER,
	READ_REPORTS_PROJ,
	READ_TEMPLATES_PROJ,
	GET_READ_TEMPLATE,
	UPDATE_REPORT,
	DELETE_REPORT,
	EDIT_PROJECTS,
	EDIT_CLUSTERS,
	GET_SVG_CIRCUIT_DRAW,
	RECOMMEND_CIRCUIT,
	BINARY_FILES_DATA_EXTRACTION,
	DELETE_SHARE_CLUSTER,
	SHARE_REPORT,
	UPDATE_SHARE_REPORT,
	DELETE_SHARE_REPORT,
	REQUEST_ENTITY_SHARE,
	CLUSTER_OWNER_DATA,
	FETCH_ACCESS_REQUESTS,
	APPROVE_RESOURCE_ACCESS_REQUESTS,
	REJECT_RESOURCE_ACCESS_REQUESTS,
	DELETE_RESOURCE_ACCESS_REQUEST,
	READ_USER_NAME,
	MANAGE_CLUSTER_ARCHIVAL,
	MANAGE_CLUSTER_FAVOURITE,
	OPT_OUT_SHARED_CLUSTER,
	FETCH_SHARED_CLUSTER_EMAILS_BY_USER
} = require('./restapi');
const store = require('../index.js');
const { default: ReportInfo } = require('../../functions/ReportInfo');
const {
	getStorage,
	ref,
	getBlob,
	listAll,
	deleteObject,
	uploadBytes,
} = require('firebase/storage');
const {
	default: notificationTerm,
} = require('@/functions/notificationTerminal.js');
const temp_index = 'temp/';

const newReponse = async function (response, code = 200, dataKey = 'data', verbosity=0) {
	//Create a new entity of reponse
	try {
		const responseData = await response.json();
		const success = response.status === code;
		const accessType = responseData.accesstype;
		const message = typeof(responseData.message) !== 'undefined' && responseData.message ? responseData.message : response.status === 403 ? 'Please verify your suscription validity and the ownership of the element' : 'Error when retrieving the information from the server, try in a few seconds'
		if (!success) {
			store.default.commit('LAST_ERROR_MIDDLEWARE', message);
		}
		if (!success && verbosity > 0) {
			notificationTerm.addNotification(
				notificationTerm.typesNotif.ERROR,
				responseData.title || response.status === 403 ? 'Insufficient Permission' : 'Internal Error',
				message,
				'Server',
				15000,
			);
		}
		return {
			success: success,
			warnings:
				typeof responseData.warnings !== 'undefined'
					? responseData.warnings
					: [],
			code: response.status,
			message: message,
			title: responseData.title,
			data:
				typeof responseData[dataKey] !== 'undefined'
					? responseData[dataKey]
					: undefined,
			pendingRequests: typeof responseData['pendingRequests'] !== 'undefined' ? responseData['pendingRequests']:'',
			action: typeof responseData['action'] !== 'undefined' ? responseData['action']:'',
			accesstype: accessType
		};
	} catch (error) {
		return {
			success: false,
			warnings: [],
			code: 500,
			message: error,
			data: {},
		};
	}
};

module.exports.getAllCluster = async () => {
	const token = store.default.getters.getTokenMiddlewareAuth;
	const response = await fetch(READ_CLUSTER_DATA, {
		method: 'GET',
		headers: {
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`,
		},
	});
	const responseFormat = await newReponse(response);
	return responseFormat;
};

module.exports.signup = async (payload) => {
	try{
		const response = await fetch(REGISTER_USER, {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({
				email: payload.email,
				password: payload.password,
				confirmPassword: payload.confirmPassword,
				username: payload.username,
				displayName: payload.displayName,
				firstName: payload.firstName,
				lastName: payload.lastName,
				phone:payload.phone,
				company: payload.company,
				title:payload.title,
				country: payload.country,
				leadSource:payload.leadSource,
				termsAccepted: payload.termsAccepted,
				privacyPolicyAccepted: payload.privacyPolicyAccepted,
				receiveNewsLetters: payload.receiveNewsLetters,
				opted_for_freemium: payload.opted_for_freemium,
				zohoAccessToken: payload.zohoAccessToken
			}),
		});
		const djuliResponseFormat = await newReponse(response);
		return djuliResponseFormat;
	}
	catch{
		const djuliResponseFormat = {success: false};
		return djuliResponseFormat;
	}
};
module.exports.getOauth = async(payload)=> {
	try {
		const response = await fetch(ZOHO_AUTH, {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({
				zohoAccessToken: payload.zohoAccessToken,
				zohoTokenExpirationTime: payload.zohoTokenExpirationTime
			}),
		})
		const zohoResponseFormat = await newReponse(response);
		return zohoResponseFormat;
	}
	catch{
		const zohoResponseFormat = {success: false};
		return zohoResponseFormat;
	}
};


module.exports.readBasicUserData = async (payload) => {
	const response = await fetch(READ_BASIC_USER_DATA, {
		method: 'POST',
		headers: { 'Content-Type': 'application/json' },
		body: JSON.stringify({
			email: payload.email,
		}),
	});
	const responseFormat = await newReponse(response);
	return responseFormat;
};
module.exports.readUserFullName = async (payload) => {
	const response = await fetch(READ_USER_NAME, {
		method: 'POST',
		headers: { 'Content-Type': 'application/json' },
		body: JSON.stringify({
			email: payload.email,
		}),
	});
	const responseFormat = await newReponse(response);
	return responseFormat;
};

module.exports.resetPassword = async (payload) => {
	const response = await fetch(RESET_PASSWORD, {
		method: 'POST',
		headers: { 'Content-Type': 'application/json' },
		body: JSON.stringify({
			email: payload.email,
		}),
	});
	const responseFormat = await newReponse(response);
	return responseFormat;
};

module.exports.resendVerification = async (payload) => {
	const response = await fetch(RESEND_VERIFICATION, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
		},
		body: JSON.stringify({
			email: payload.email,
		}),
	});
	const responseFormat = await newReponse(response);
	return responseFormat;
};

module.exports.addCluster = async (payload) => {
	const token = store.default.getters.getTokenMiddlewareAuth;
	const response = await fetch(ADD_CLUSTER, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`,
		},
		body: JSON.stringify({
			clusterName: payload.clusterName,
		}),
	});
	const responseFormat = await newReponse(response, 201);
	return responseFormat;
};
module.exports.addReport = async (payload) => {
	const token = store.default.getters.getTokenMiddlewareAuth;
	const response = await fetch(
		ADD_REPORT(payload.clusterId, payload.projectId, 'report'),
		{
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token}`,
			},
			body: JSON.stringify({
				report_name: payload.report_name,
			}),
		},
	);
	const responseFormat = await newReponse(response);
	return responseFormat;
};
module.exports.addHyperlinkReport = async (payload) => {
	const token = store.default.getters.getTokenMiddlewareAuth;
	const response = await fetch(
		ADD_REPORT(payload.clusterId, payload.projectId, 'hyperlinkReport'),
		{
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token}`,
			},
			body: JSON.stringify({
				clusterIdLink: payload.clusterIdLink,
				projectIdLink: payload.projectIdLink,
				reportIdLink: payload.reportIdLink,
			}),
		},
	);
	const responseFormat = await newReponse(response);
	return responseFormat;
};

module.exports.addComparisonReport = async (payload) => {
	const token = store.default.getters.getTokenMiddlewareAuth;
	const response = await fetch(
		ADD_REPORT(payload.clusterId, payload.projectId, 'comparativeReport'),
		{
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token}`,
			},
			body: JSON.stringify({
				report_name: payload.report_name,
				comparing: payload.comparing,
			}),
		},
	);
	const responseFormat = await newReponse(response);
	return responseFormat;
};

module.exports.getProjectsClust = async (payload) => {
	const clusterId = payload.clusterId;
	const token = store.default.getters.getTokenMiddlewareAuth;
	const response = await fetch(READ_PROJECTS_CLUST(clusterId), {
		method: 'GET',
		headers: {
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`,
		},
	});
	const responseFormat = await newReponse(response);
	return responseFormat;
};

module.exports.getReportsProj = async (payload) => {
	const projectId = payload.projectId;
	const clusterId = payload.clusterId;
	const token = store.default.getters.getTokenMiddlewareAuth;
	const response = await fetch(
		READ_REPORTS_PROJ(clusterId, projectId),
		{
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token}`,
			},
		},
	);
	const responseFormat = await newReponse(response);
	return responseFormat;
};
module.exports.readUsersSharing = async () => {
	const token = store.default.getters.getTokenMiddlewareAuth;
	const response = await fetch(SHARED_DETAILS, {
		method: 'GET',
		headers: {
			Authorization: `Bearer ${token}`,
		},
	});
	const responseFormat = await newReponse(response);
	return responseFormat;
};

module.exports.getSingleReport = async (payload) => {
	try {
		const clusterId = payload.clusterId;
		const projectId = payload.projectId;
		const reportId = payload.reportId;
		const token = store.default.getters.getTokenMiddlewareAuth;
		const response = await fetch(
			READ_REPORT(clusterId, projectId, reportId),
			{
				method: 'GET',
				headers: {
					'Content-Type': 'application/json',
					Authorization: `Bearer ${token}`,
				},
			},
		);
		const responseFormat = await newReponse(response);
		if (!responseFormat.success) {
			return responseFormat;
		}
		const accesstype = responseFormat.data.accesstype;
		const owner = responseFormat.data.owner;
		if (typeof responseFormat.data.report !== 'undefined') {
			responseFormat.data = responseFormat.data.report;
		} else {
			const tempLocation = responseFormat.data.tempFileLocation;
			const storage = getStorage();
			const refFile = ref(storage, tempLocation);
			const reportStream = await getBlob(refFile);
			const fileText = await readFileAsText(reportStream);
			responseFormat.data = JSON.parse(fileText);
			await deleteObject(refFile);
		}
		responseFormat.data.accesstype = accesstype;
		responseFormat.data.owner = owner;
		return responseFormat;
	} catch (error) {
		return {
			success: false,
			warnings: [],
			code: 500,
			message: error,
			data: {},
		};
	}
};

const readFileAsText = async (file) => {
	let result_base64 = await new Promise((resolve) => {
		let fileReader = new FileReader();
		fileReader.onload = () => resolve(fileReader.result);
		fileReader.readAsText(file);
	});
	return result_base64;
};

var saveData = (function () {
	var a = document.createElement('a');
	document.body.appendChild(a);
	a.style = 'display: none';
	return function (blob, fileName) {
		var url = window.URL.createObjectURL(blob);
		a.href = url;
		a.download = fileName;
		a.click();
		window.URL.revokeObjectURL(url);
	};
})();

module.exports.downloadRawFiles = async (payload) => {
	const projectId = payload.projectId;
	const reportId = payload.reportId;
	const clusterId = payload.clusterId;
	const token = store.default.getters.getTokenMiddlewareAuth;
	try {
		const response = await fetch(
			DOWNLOAD_RAW_FILES(clusterId, projectId, reportId),
			{
				method: 'GET',
				headers: {
					'Content-Type': 'application/json',
					Authorization: `Bearer ${token}`,
				},
			},
		);
		const responseFormat = await newReponse(response);
		if (!responseFormat.success) {
			return responseFormat;
		}
		const tempFolderLocation = responseFormat.data.tempFolderLocation;
		const userId = store.default.getters.getUserIdMiddlewareAuth;
		if (
			tempFolderLocation === null ||
			typeof tempFolderLocation === 'undefined' ||
			tempFolderLocation === '' ||
			!tempFolderLocation.startsWith(`temp/${userId}/`)
		) {
			return { success: false };
		}
		const storage = getStorage();
		const refList = ref(storage, tempFolderLocation);
		const listFiles = await listAll(refList);
		for (let j = 0; j < listFiles.items.length; j++) {
			const blob = await getBlob(listFiles.items[j]);
			saveData(blob, listFiles.items[j].name);
			deleteObject(listFiles.items[j]);
		}
		return { success: true };
	} catch (error) {
		return { success: false };
	}
};

module.exports.updateReport = async (payload) => {
	const verbosity = typeof(payload.verbosity) === 'undefined'? 1 : payload.verbosity;
	const report = payload.report;
	const projectId = report.projectId;
	const reportId = report.id;
	const clusterId = payload.clusterId;
	const userId = store.default.getters.getUserIdMiddlewareAuth;

	const lightReport = ReportInfo.getLightReport(report); //Get the light version of the report
	const typeFile = 'application/json';
	const reportFile = new Blob([JSON.stringify(report, null, 2)], {
		type: typeFile,
	});
	const fileName = `${report.id}.json`;
	const storage = getStorage();
	const storageRef = ref(storage, `${temp_index}${userId}/${fileName}`);
	await uploadBytes(storageRef, reportFile);

	const token = store.default.getters.getTokenMiddlewareAuth;
	const response = await fetch(
		UPDATE_REPORT(clusterId, projectId, reportId),
		{
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token}`,
			},
			body: JSON.stringify({
				lightReport,
				fileName,
			}),
		},
	);
	const responseFormat = await newReponse(response, undefined, undefined, verbosity);
	return responseFormat;
};

module.exports.removeReport = async (payload) => {
	const projectId = payload.projectId;
	const reportId = payload.reportId;
	const clusterId = payload.clusterId;

	const token = store.default.getters.getTokenMiddlewareAuth;
	const response = await fetch(
		DELETE_REPORT(clusterId, projectId, reportId),
		{
			method: 'DELETE',
			headers: {
				Authorization: `Bearer ${token}`,
			},
		},
	);
	const responseFormat = await newReponse(response);
	return responseFormat;
};

module.exports.extractBinary = async (payload) => {
	const fileName = payload.filename;
	const formData = new FormData();
	formData.append(fileName, payload.file, fileName);
	const token = store.default.getters.getTokenMiddlewareAuth;
	const response = await fetch(BINARY_FILES_DATA_EXTRACTION, {
		method: 'POST',
		body: formData,
		headers: {
			Authorization: `Bearer ${token}`,
		},
	});
	const responseFormat = await newReponse(response, 200, 'dataGraph');
	return responseFormat;
};

module.exports.drawCircuit = async (payload) => {
	const token = store.default.getters.getTokenMiddlewareAuth;
	const response = await fetch(
		GET_SVG_CIRCUIT_DRAW(payload.config.circ),
		{
			method: 'GET',
			headers: {
				Authorization: `Bearer ${token}`,
			},
		},
	);
	const responseFormat = await newReponse(response, 200, 'dataGraph');
	return responseFormat;
};

module.exports.recommendCircuit = async (payload) => {
	const token = store.default.getters.getTokenMiddlewareAuth;
	const response = await fetch(RECOMMEND_CIRCUIT, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`,
		},
		body: JSON.stringify({
			payload,
		}),
	});
	const responseFormat = await newReponse(response, 200, 'data');
	return responseFormat;
};

module.exports.saveRawFile = async (payload) => {
	const projectId = payload.projectId;
	const reportId = payload.reportId;
	const clusterId = payload.clusterId;
	const fileName = payload.filename;

	const userId = store.default.getters.getUserIdMiddlewareAuth;
	const storage = getStorage();
	const storageRef = ref(storage, `${temp_index}${userId}/${fileName}`);
	await uploadBytes(storageRef, payload.file);
	const token = store.default.getters.getTokenMiddlewareAuth;
	const response = await fetch(
		ADD_RAW_FILE(clusterId, projectId, reportId),
		{
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token}`,
			},
			body: JSON.stringify({
				fileName: fileName,
			}),
		},
	);
	const responseFormat = await newReponse(response);
	return responseFormat;
};

module.exports.addProject = async (payload) => {
	const token = store.default.getters.getTokenMiddlewareAuth;
	const clusterId = payload.clusterId; // it should be taken from the cluster response
	const response = await fetch(ADD_PROJECTS(clusterId), {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`,
		},
		body: JSON.stringify({
			projectName: payload.projectName,
		}),
	});
	const responseFormat = await newReponse(response, 201);
	return responseFormat;
};

module.exports.editProject = async (payload) => {
	const token = store.default.getters.getTokenMiddlewareAuth;
	const response = await fetch(
		EDIT_PROJECTS(payload.clusterId, payload.projectId),
		{
			method: 'PUT',
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token}`,
			},
			body: JSON.stringify({
				projectName: payload.newText,
			}),
		},
	);
	const responseFormat = await newReponse(response);
	return responseFormat;
};

module.exports.editCluster = async (payload) => {
	const token = store.default.getters.getTokenMiddlewareAuth;
	const clusterId = payload.clusterId; // it should be taken from the cluster response
	const response = await fetch(EDIT_CLUSTERS(clusterId), {
		method: 'PUT',
		headers: {
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`,
		},
		body: JSON.stringify({
			clusterName: payload.newText,
		}),
	});
	const responseFormat = await newReponse(response);
	return responseFormat;
};

module.exports.requestTemplateList = async (payload) => {
	const token = store.default.getters.getTokenMiddlewareAuth;
	const response = await fetch(
		READ_TEMPLATES_PROJ(payload.clusterId, payload.projectId),
		{
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token}`,
			},
		},
	);
	const responseFormat = await newReponse(response);
	return responseFormat;
};

module.exports.getSingleTemplate = async (payload) => {
	const token = store.default.getters.getTokenMiddlewareAuth;
	const response = await fetch(
		GET_READ_TEMPLATE(payload.clusterId, payload.projectId, payload.templateId),
		{
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token}`,
			},
		},
	);
	const responseFormat = await newReponse(response);
	return responseFormat;
};

module.exports.addTemplate = async (payload) => {
	const verbosity = typeof(payload.verbosity) === 'undefined'? 1 : payload.verbosity;
	const token = store.default.getters.getTokenMiddlewareAuth;
	const name = payload.name;
	const type = payload.type;
	const source = payload.source;
	const response = await fetch(
		ADD_TEMPLATE(payload.clusterId, payload.projectId),
		{
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token}`,
			},
			body: JSON.stringify({
				templateName: name,
				templateType: type,
				source: source,
			}),
		},
	);
	const responseFormat = await newReponse(response, undefined, undefined, verbosity);
	return responseFormat;
};

module.exports.updateTemplate = async (payload) => {
	const verbosity = typeof(payload.verbosity) === 'undefined'? 1 : payload.verbosity;
	const token = store.default.getters.getTokenMiddlewareAuth;
	const response = await fetch(
		UPDATE_TEMPLATE(payload.clusterId, payload.projectId, payload.templateId),
		{
			method: 'PUT',
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token}`,
			},
			body: JSON.stringify({
				templateName: payload.name,
				templateType: payload.type,
			}),
		},
	);
	const responseFormat = await newReponse(response, undefined, undefined, verbosity);
	return responseFormat;
};

module.exports.requestMultipleTemplatesFile = async (payload) => {
	const token = store.default.getters.getTokenMiddlewareAuth;
	const templates = payload.templates;
	const response = await fetch(
		FILES_TEMPLATE(payload.clusterId, payload.projectId),
		{
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token}`,
			},
			body: JSON.stringify({
				templates: templates,
			}),
		},
	);
	if (response.status !== 200) {
		const responseFormat = await newReponse(response);
		return responseFormat;
	}
	const blob = await response.blob();
	if (templates.length > 1) {
		saveData(blob, 'TemplateFiles.zip');
	} else {
		saveData(blob, `${templates[0].name}.json`);
	}
	return { success: true };
};

module.exports.removeTemplate = async (payload) => {
	const verbosity = typeof(payload.verbosity) === 'undefined'? 1 : payload.verbosity;
	const token = store.default.getters.getTokenMiddlewareAuth;
	const response = await fetch(
		REMOVE_TEMPLATE(payload.clusterId, payload.projectId, payload.templateId),
		{
			method: 'DELETE',
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token}`,
			},
		},
	);
	const responseFormat = await newReponse(response, undefined, undefined, verbosity);
	return responseFormat;
};

module.exports.shareCluster = async (payload) => {
	const token = store.default.getters.getTokenMiddlewareAuth;
	const clusterId = payload.clusterId;
	const users = payload.users;
	const clusterName = payload.clusterName;
	const response = await fetch(SHARE_CLUSTER, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`,
		},
		body: JSON.stringify({
			users,
			clusterId,
			clusterName,
		}),
	});
	const responseFormat = await newReponse(response, 201);
	return responseFormat;
};

module.exports.updateShareCluster = async (payload) => {
	const token = store.default.getters.getTokenMiddlewareAuth;
	const clusterId = payload.clusterId;
	const users = payload.users;
	const response = await fetch(UPDATE_SHARE_CLUSTER(clusterId), {
		method: 'PUT',
		headers: {
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`,
		},
		body: JSON.stringify({
			users,
		}),
	});
	const responseFormat = await newReponse(response);
	return responseFormat;
};

module.exports.deleteShareCluster = async (payload) => {
	const token = store.default.getters.getTokenMiddlewareAuth;
	const clusterId = payload.clusterId;
	const users = payload.users;
	const response = await fetch(DELETE_SHARE_CLUSTER, {
		method: 'DELETE',
		headers: {
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`,
		},
		body: JSON.stringify({
			emailsList: users,
			clusterId,
		}),
	});
	const responseFormat = await newReponse(response);
	return responseFormat;
};
module.exports.shareReport = async (payload) => {
	const token = store.default.getters.getTokenMiddlewareAuth;
	const reports = payload.reports;
	const users = payload.users;
	const clusterName = payload.clusterName;
	const clusterId = payload.clusterId;
	const response = await fetch(SHARE_REPORT, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`,
		},
		body: JSON.stringify({
			users,
			reports,
			clusterName,
			clusterId,
		}),
	});
	const responseFormat = await newReponse(response, 201);
	return responseFormat;
};

module.exports.updateShareReport = async (payload) => {
	const token = store.default.getters.getTokenMiddlewareAuth;
	const reports = payload.reports;
	const users = payload.users;
	const response = await fetch(UPDATE_SHARE_REPORT, {
		method: 'PUT',
		headers: {
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`,
		},
		body: JSON.stringify({
			users,
			reports,
		}),
	});
	const responseFormat = await newReponse(response);
	return responseFormat;
};

module.exports.deleteShareReport = async (payload) => {
	const token = store.default.getters.getTokenMiddlewareAuth;
	const reports = payload.reports;
	const users = payload.users;
	const response = await fetch(DELETE_SHARE_REPORT, {
		method: 'DELETE',
		headers: {
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`,
		},
		body: JSON.stringify({
			emailsList: users,
			reports,
		}),
	});
	const responseFormat = await newReponse(response);
	return responseFormat;
};
module.exports.sendResourceAccessRequest = async (payload) => {
	const token = store.default.getters.getTokenMiddlewareAuth;
	const sender = payload.sender;
	const receiver = payload.receiver;
	const subject = payload.subject;
	const message = payload.message;
	const resourceType = payload.resourceType;
	const entityName = payload.entityName;
	const linkObj = payload.linkObj;
	// Check for the resosurce type being requested
	let entityId = null;
	if(resourceType.toLowerCase() ==='cluster'){
		entityId = linkObj.clusterId;
	}
	else if(resourceType.toLowerCase() ==='project'){
		entityId = linkObj.projectId;
	}
	else{
		entityId = linkObj.reportId;
	}
	const response = await fetch(`${REQUEST_ENTITY_SHARE}/${entityId}`, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`,
		},
		body: JSON.stringify({
			sender: sender,
			receiver: receiver,
			subject: subject,
			message: message,
			resourceType: resourceType,
			entityName: entityName,
			linkObj: linkObj
		}),
	});
	const responseFormat = await newReponse(response);
	return responseFormat;
};
module.exports.getClusterOwnerData = async(payload)=>{
	const token = store.default.getters.getTokenMiddlewareAuth;
	const response = await fetch(`${CLUSTER_OWNER_DATA}/${payload.clusterId}`, {
		method: 'GET',
		headers: {
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`,
		},
	});
	const responseFormat = await newReponse(response);
	return responseFormat;
}
module.exports.fetchResourceAccessRequests = async (payload) =>{
	const token = store.default.getters.getTokenMiddlewareAuth;
	const userId = payload.email;
	const response = await fetch(FETCH_ACCESS_REQUESTS(userId), {
		method: 'GET',
		headers: {
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`
			//'X-User-Email': payload.email
		},
	});
	const responseFormat = await newReponse(response);
	return responseFormat;
}
module.exports.approveResourceAccessRequest = async (payload) =>{
	const verbosity = typeof(payload.verbosity) === 'undefined'? 1 : payload.verbosity;
	const token = store.default.getters.getTokenMiddlewareAuth;
	const response = await fetch(APPROVE_RESOURCE_ACCESS_REQUESTS(payload.requestId), {
		method: 'PUT',
		headers: {
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`
		},
	});
	const responseFormat = await newReponse(response, undefined, undefined, verbosity);
	return responseFormat;
}
module.exports.rejectResourceAccessRequest = async (payload) =>{
	const verbosity = typeof(payload.verbosity) === 'undefined'? 1 : payload.verbosity;
	const token = store.default.getters.getTokenMiddlewareAuth;
	const response = await fetch(REJECT_RESOURCE_ACCESS_REQUESTS(payload.requestId), {
		method: 'PUT',
		headers: {
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`
		}
	});
	const responseFormat = await newReponse(response, undefined, undefined, verbosity);
	return responseFormat;
}
module.exports.deleteResourceAccessRequest= async (payload) =>{
	const verbosity = typeof(payload.verbosity) === 'undefined'? 1 : payload.verbosity;
	const token = store.default.getters.getTokenMiddlewareAuth;
	const response = await fetch(DELETE_RESOURCE_ACCESS_REQUEST(payload.requestId), {
		method: 'DELETE',
		headers: {
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`
		}
	});
	const responseFormat = await newReponse(response, undefined, undefined, verbosity);
	return responseFormat;
}
module.exports.manageClusterArchival = async (payload) => {
	const token = store.default.getters.getTokenMiddlewareAuth;
	const clusterId = payload.clusterId; // it should be taken from the cluster response
	const response = await fetch(MANAGE_CLUSTER_ARCHIVAL(clusterId), {
		method: 'PUT',
		headers: {
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`,
		},
		body: JSON.stringify({
			isArchived: payload.isArchived
		}),
	});
	const responseFormat = await newReponse(response);
	return responseFormat;
}
module.exports.manageClusterFavourite = async (payload) => {
	const token = store.default.getters.getTokenMiddlewareAuth;
	const clusterId = payload.clusterId; // it should be taken from the cluster response
	const response = await fetch(MANAGE_CLUSTER_FAVOURITE(clusterId), {
		method: 'PUT',
		headers: {
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`,
		},
		body: JSON.stringify({
			isFavourite: payload.isFavourite,
			clusterId: clusterId
		}),
	});
	const responseFormat = await newReponse(response);
	return responseFormat;
}
module.exports.optOutSharedCluster = async (payload) => {
	const token = store.default.getters.getTokenMiddlewareAuth;
	const clusterId = payload.clusterId; // it should be taken from the cluster response
	const response = await fetch(OPT_OUT_SHARED_CLUSTER(clusterId), {
		method: 'PUT',
		headers: {
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`,
		}
	});
	const responseFormat = await newReponse(response);
	return responseFormat;
}
module.exports.sharedClusterEmailsByUser = async (payload) => {
	const token = store.default.getters.getTokenMiddlewareAuth;
	const userId = payload.email;
	const response = await fetch(FETCH_SHARED_CLUSTER_EMAILS_BY_USER(userId), {
		method: 'GET',
		headers: {
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`,
		}
	});
	const responseFormat = await newReponse(response);
	return responseFormat;
}





